<template>
  <div class="relative">
    <div class="rounded-lg overflow-hidden">
      <div class="divide-y divide-brand-sand lg:grid lg:grid-cols-12 lg:divide-y-0 lg:divide-x">
        <div class="lg:col-span-12">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Settings',
};
</script>
